import React from 'react';
import TextArea from 'components/shared/debouncedTextArea';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const ElementPrompt = ({
  applyChanges,
  handleUpdate,
  content,
  hasChoices,
  isRequired,
}) => {
  const { subject } = content;
  return (
    <div className="w-100p border border-gray-light border-top-0 border-bottom-0 pl-32 pr-32">
      <div className="pt-32 pb-8" data-test-id="prompt">
        <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}>
          {hasChoices
            ? t('lessons.editor.elements.question')
            : t('questions.element.prompt')}
        </Text>
        {isRequired && <span className="c-danger-red"> * </span>}
      </div>
      <Text
        variant={TEXT_VARIANTS.TITLE_BOLD}
        component={TextArea}
        className="EditorElement-input UnifiedPromptInput"
        placeholder={
          hasChoices
            ? t('questions.element.ask_question')
            : t('questions.element.prompt_placeholder')
        }
        value={subject}
        onChange={value => {
          applyChanges({ subject: value });
          handleUpdate({ subject: value });
        }}
        singleLine
      />
    </div>
  );
};

export default ElementPrompt;
